import React, { useState } from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import VerticalDotsIcon from '@mui/icons-material/MoreVert';
import AddIcon from '@mui/icons-material/Add';
import LabelIcon from '@mui/icons-material/LabelOutlined';
import FileUploadIcon from '@mui/icons-material/FileUploadOutlined';
import FilterIcon from '@mui/icons-material/FilterListRounded';

import { Flex } from 'src/components/flex';
import { ImportLeads } from 'src/components/bulk-import';
import PageHeader from 'src/components/page-header';
import Responsive from 'src/components/responsive';
import { useLeadsPageContext } from 'src/pages/landlord/leads/provider';
import Search from 'src/pages/landlord/leads/components/header/LeadsSearch';
import LeadsFilterButton from 'src/pages/landlord/leads/components/header/LeadsFilterButton';
import SelectGrouping from 'src/pages/landlord/leads/components/header/SelectGrouping';
import FilterStatus from 'src/pages/landlord/leads/components/header/LeadsFilterStatus';
import SortLeads from 'src/pages/landlord/leads/components/header/SortLeads';

export default function LeadsHeader() {
    const {
        setIsCreateLeadModalOpen,
        setIsEditLeadLabelsModalOpen,
        setFilterOpen,
    } = useLeadsPageContext();

    const [isImportLeadsModalOpen, setIsImportLeadsModalOpen] = useState(false);

    const [anchorEl, setAnchorEl] = useState<HTMLElement>();
    const closeMenu = () => setAnchorEl(undefined);

    return (
        <>
            <PageHeader
                search={(
                    <Flex alignItems="center" width="100%">
                        <Search />
                        <Responsive desktop>
                            <Flex width={150} sx={{ flexShrink: 0 }}>
                                <SelectGrouping />
                            </Flex>
                        </Responsive>
                    </Flex>
                )}
                controls={(
                    <Responsive mobile>
                        <Flex width="100%">
                            <SelectGrouping />
                        </Flex>
                    </Responsive>
                )}
                filter={<LeadsFilterButton />}
                sort={<SortLeads />}
                actions={(
                    <>
                        <Flex
                            justifyContent="flex-end"
                            sx={{ '@media (max-width: 1200px)': { display: 'none' } }}
                        >
                            <Button
                                variant="contained"
                                onClick={() => setIsCreateLeadModalOpen(true)}
                                startIcon={<AddIcon />}
                                data-testid="new-lead-button"
                            >
                                New Lead
                            </Button>

                            <Button
                                variant="outlined"
                                onClick={() => setIsImportLeadsModalOpen(true)}
                                startIcon={<FileUploadIcon />}
                                data-testid="import-leads-button"
                            >
                                Import Leads
                            </Button>

                            <Button
                                variant="outlined"
                                onClick={() => setIsEditLeadLabelsModalOpen(true)}
                                startIcon={<LabelIcon />}
                                data-testid="lead-labels-button"
                            >
                                Labels
                            </Button>
                        </Flex>

                        <IconButton
                            onClick={(e) => setAnchorEl(e.currentTarget)}
                            edge="end"
                            sx={{ '@media (min-width: 1201px)': { display: 'none' } }}
                        >
                            <VerticalDotsIcon />
                        </IconButton>
                    </>
                )}
                status={<FilterStatus />}
            />

            <Menu
                anchorEl={anchorEl}
                open={!!anchorEl}
                onClose={closeMenu}
            >
                <MenuItem onClick={() => {
                    setIsCreateLeadModalOpen(true);
                    closeMenu();
                }}
                >
                    <ListItemIcon>
                        <AddIcon />
                    </ListItemIcon>
                    <ListItemText>
                        <Typography>New Lead</Typography>
                    </ListItemText>
                </MenuItem>

                <MenuItem onClick={() => {
                    setIsEditLeadLabelsModalOpen(true);
                    closeMenu();
                }}
                >
                    <ListItemIcon>
                        <LabelIcon />
                    </ListItemIcon>
                    <ListItemText>
                        <Typography>Labels</Typography>
                    </ListItemText>
                </MenuItem>

                <MenuItem onClick={() => {
                    setFilterOpen(true);
                    closeMenu();
                }}
                >
                    <ListItemIcon>
                        <FilterIcon />
                    </ListItemIcon>
                    <ListItemText>
                        <Typography>Filter</Typography>
                    </ListItemText>
                </MenuItem>
            </Menu>

            {isImportLeadsModalOpen && (
                <ImportLeads
                    isOpened={isImportLeadsModalOpen}
                    onClose={() => setIsImportLeadsModalOpen(false)}
                />
            )}
        </>
    );
}
